<!-- <nav class="navbar navbar-expand-lg navbar-light brown-color-bg shadow-new">
    <div class="container-fluid">
        <a class="navbar-brand text-white" routerLink="/home"><img src="assets/img/maha_track_logo2.png" width="60px"> <span class="ml-2">MAHAMINING TRACK</span></a>
        <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
            <span class="navbar-toggler-icon"></span>
        </button> -->

        <!-- <div class="collapse navbar-collapse" id="navbarSupportedContent">
            <ul class="navbar-nav ml-auto">
                <li class="nav-item">
                    <a class="nav-link" routerLink="/home" routerLinkActive="active">Home</a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" routerLink="/about" routerLinkActive="active">About</a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" routerLink="/faq" routerLinkActive="active">FAQ</a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" routerLink="/contact" routerLinkActive="active">Contact</a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" routerLink="/login" routerLinkActive="active">Login</a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" routerLink="/register" routerLinkActive="active">Register</a>
                </li>
            </ul>

        </div> 
    </div>
</nav> -->

<div class="headerMain">
    <div class="topHeader">
        <div class="container-fluid container-lg">
            <div class="row align-items-center">
                <div class="col-sm-12 col-md-6 col-lg-6">
                    <div class="logoImgStyle text-center text-md-left text-lg-left mb-2 mb-md-0 mb-lg-0 d-flex align-items-center"><img src="assets/img/maha_track_logo2.png" alt="Logo"  routerLink="login"/><span>mahakhanij Track</span></div>
                </div>
                <div class="col-sm-12 col-md-6 col-lg-6">
                    <div class="topRightMenu">
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>